import request from "@/utils/axios";

//  获取行业下拉列表信息
export function INDUSTRYS(data) {
  return request({
    url: '/api/industrybrand/industrys',
    method: 'get',
    data
  })
}
//  获取品牌下拉列表信息
export function BRANDS(data) {
  return request({
      url: '/api/industrybrand/brands',
      method: 'post',
      data
  })
}
//  获取联盟客平台logos
export function PLATFORMLOGOS(data) {
  return request({
    url: '/api/industrybrand/platformLogos',
    method: 'get',
    data
  })
}
//  获取行业下品牌列表信息
export function BRANDSBYINDUSTRY(data) {
  return request({
    url: '/api/industrybrand/brandsByIndustry',
    method: 'post',
    data
  })
} 
//  根据行业获取联盟客信息  /allianceguest/industry
export function INDUSTRYY(data) {
  return request({
    url: '/api/allianceguest/industry',
    method: 'post',
    // noloading: true,
    data
  })
}
//  根据行业获取联盟客信息  /allianceguest/industry
export function BRAND(data) {
  return request({
    url: '/api/allianceguest/brand',
    method: 'post',
    data
  })
}

//  检查用户是否有行业或品牌权限  /api/industrybrand/check/{permitType}/permit/{permitCode}
export function CHECKBRAND(data) {
  return request({
    url: '/api/industrybrand/check/'+data.permitType+'/permit/'+data.permitCode,
    method: 'get'
  })
}
//  行业情报/竞品情报-根据品牌获取国家及国家下各种数据
export function COUNTRYBRAND(data) {
  return request({
    url: '/api/industrybrand/countryBrand',
    method: 'post',
    data
  })
}

//  洞察情报-查询联盟客筛选条件
export function QUERYSELECTLIST(data) {
  return request({
    url: '/api/allianceguest/querySelectList',
    method: 'get',
    data
  })
}

//  分组-查询用户下全部分组
export function QUERYUSERGROUP(data) {
  return request({
    url: '/api/group/queryUserGroup',
    method: 'get',
    data
  })
}

//  个人中心-获取登录信息

export function QUERY(data) {
  return request({
    url: '/api/users/query',
    method: 'get',
    data
  })
}

//  分组-加入分组（批量/单个）

export function JOINGROUP(data) {
  return request({
    url: '/api/group/joinGroup',
    method: 'post',
    data
  })
}

//  搜索行业/品牌(全检)
export function CHECKALLINDUSTRYBRAND(data) {
  return request({
    url: '/api/industrybrand/checkAllIndustryBrand',
    method: 'POST',
    data
  })
}
//  搜索行业/品牌(全检)
export function QUERYHASGROUP(data) {
  return request({
    url: '/api/allianceguest/queryHasGroup',
    method: 'POST',
    data
  })
}


//  联盟客详情报表
export function QUERYDETAILCHARTS(data) {
  return request({
    url: '/api/allianceguest/queryChannelDetailsCharts',
    method: 'POST',
    data
  })
}

//  联盟客详情报表
export function QUERYDETAILClOUDWORD(data) {
  return request({
    url: '/api/allianceguest/queryChannelContentCharts',
    method: 'POST',
    data
  })
}


//  youtube视频
export function QUERYVIDEOLINKS(data) {
  return request({
    url: '/api/allianceguest/queryChannelVideoLinks',
    method: 'POST',
    data
  })
}

//  问答库列表
export function QUERYCHATLIST(data) {
  return request({
    url: '/api/intelligence/chat/list',
    method: 'GET',
    data
  })
}

//  问答库发送
export function QUERYCHAT(data) {
  return request({
    url: '/api/chat/question/test',
    method: 'GET',
    data
  })
}





